<template>
  <div class="table-wrapper d-flex flex-column flex-grow-1" v-if="initialized">
    <TableHeaderPanel :loading="loading"
                      hideSearchBar
                      :limit="this.limit"
                      :addNewButton="addNewButton"
                      @update-limit="updateLimit"
                      @reset="resetPreferences"/>
    <div class="table-responsive">
      <table class="table table-curved table-td-align-middle">
        <CustomTableHeader :columnConfig="columnConfig"
                     :sortField="sortField"
                     :order="order"
                     ref="header"/>
        <TableBody v-on="$listeners"
                   :list="list"
                   :columnConfig="columnConfig"
                   :start="start"
                   :selected="selected"
                   ref="body"
                   v-if="hasContent"/>
      </table>
    </div>
  </div>
</template>

<script>
import CustomTableHeader from './CustomTableHeader.vue'
import TableBody from './TableBody.vue'
import TableHeaderPanel from './TableHeaderPanel.vue'
export default {
  name: 'CustomListingComponent',
  components: {
    CustomTableHeader,
    TableBody,
    TableHeaderPanel
  },
  props: {
    requestProvider: {
      type: Function,
      required: true
    },
    columnConfig: {
      type: Array,
      default: () => [],
      required: true
    },
    addNewButton: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      initialized: false,
      list: [],
      totalCount: 0,
      searchKey: '',
      start: 0,
      limit: 30,
      sortField: '',
      order: 0,
      selected: [],
      startDate: null,
      endDate: null
    }
  },
  computed: {
    hasContent () {
      return this.totalCount
    }
  },
  created () {
    this.onInitialize()
  },
  methods: {
    onInitialize () {
      this.$nextTick(() => {
        this.initialized = true
      })
      this.doRequest()
    },
    resetPreferences () {
      this.start = 0
      this.searchKey = ''
      this.startDate = null
      this.endDate = null
      this.onInitialize()
    },
    updateLimit (limit) {
      this.limit = limit

      this.doRequest()
    },
    doRequest () {
      this.loading = true

      this.$loading.show()
      this.requestProvider(this.getRequestParams())
        .then(data => {
          if (data && data.data) {
            this.loading = false

            this.list = data.data.items
            this.totalCount = data.data.count || 0
          }
          this.$loading.hide()
        }).catch((e) => {
          this.loading = false
          this.$loading.hide()
        })
    },
    getSortOrder () {
      if (this.order === 0) {
        return 'asc'
      }
      return 'desc'
    },
    getRequestParams () {
      const listParams = {
        start: this.start,
        limit: this.limit,
        searchKey: this.searchKey,
        sortField: this.sortField,
        sortOrder: this.getSortOrder()
      }
      let filterParams = {}
      if (this.$refs.filterModal && this.$refs.filterModal.filterData) {
        filterParams = this.$refs.filterModal.filterData
      } else if (this.selectDefaultDate) {
        const date = new Date()
        date.setHours(date.getHours() - 24)
        filterParams = {
          startTime: new Date(date).getTime(),
          endTime: new Date().getTime()
        }
      }
      const params = {
        ...listParams,
        ...filterParams

      }
      return { params }
    }
  }
}
</script>

<style scoped>

</style>
